module.exports = __webpack_public_path__ + "static/media/dummy-three.98f5db4a.jpeg";